<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <div class="code">{{sum_revenue}} <span style="font-size: 20px"> ￥</span></div>
            <div class="top-text">累计收益</div>
        </div>

        <div class="main">
            <div class="main-top">
                <div class="main-top-num">{{today_revenue}}</div>
                <div class="main-top-text">今日收益</div>
            </div>
            <div class="main-top" @click="goTotals(period_id)">
                <div class="main-top-num">{{period_revenue}}</div>
                <div class="main-top-text">本周期收益</div>
            </div>
            <div class="main-top" @click="goSeeds">
                <div class="main-top-num">{{sum_children_revenue}}</div>
                <div class="main-top-text">下层收益</div>
            </div>
        </div>

        <div class="main" style="min-height: 400px">
            <div class="main-option">
                <div class="main-option-item" :class="{ action: action.all}" @click="optionConfirm(0)">全部收益</div>
                <div class="main-option-item" :class="{ action: action.exc}" @click="optionConfirm(2)">交换卡</div>
                <div class="main-option-item" :class="{ action: action.chat}" @click="optionConfirm(4)">畅聊卡</div>
                <div class="main-option-item" :class="{ action: action.vip}" @click="optionConfirm(3)">会员VIP</div>
            </div>
            <div class="main-list" :style="marSty">
                <van-list
                    v-model:loading="loading"
                    :finished="finished"
                    :finished-text="loadingText"
                    @load="onLoad"
                >
                    <div class="main-list-info" v-for="item in list" :key="item.withdraw_id" :title="item">
                        <div class="main-list-info-name">
                            {{item.app_nickname}}
                        </div>
                        <div class="main-list-info-price">
                            {{item.revenue_money}}
                        </div>
                        <div class="main-list-info-text">
                            {{item.revenue_title}}
                        </div>
                        <div class="main-list-info-time">
                            {{item.create_time}}
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
        <ReferralFooter index="2"/>
    </div>
</template>

<script>

import {showFailToast} from "vant";
import ReferralFooter  from "@/components/referralFooter.vue";
import ayzAjax from "@/plugins/axios";

export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            sum_revenue:0,//总收益
            today_revenue:0,//今日
            period_revenue:0,//周期
            period_id:0,//周期id
            sum_children_revenue:0,//下层
            list:[],
            loading:false,
            finished:false,
            option:0,
            jwtInfo:null,
            userInfo:null,
            page:1,
            loadingText: '暂无数据',
            marSty:{},
            action:{
                all:true,
                exc:false,
                chat:false,
                vip:false,
            },
        }
    },
    created() {
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        // console.log(this.jwtInfo);
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    },
    methods: {
        goSeeds(){
            this.$router.push({ path: '/referral/seeds'});
        },
        goTotals(id){
            if (parseInt(id) === 0)return false;
            this.$router.push({ path: '/referral/totals', query: { id:id} });
        },
        optionConfirm(type){
            if (type === this.option){
                return false;
            }
            this.option = type;
            for (let actionKey in this.action) {
                this.action[actionKey] = false;
            }
            if (this.option === 0){
                this.action.all = true;
            }else if (this.option === 2){
                this.action.exc = true;
            }else if (this.option === 3){
                this.action.vip = true;
            }else if (this.option === 4){
                this.action.chat = true;
            }

            this.list = [];
            this.page = 1;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad(){
            let url = '/referral/all_revenues?page=' + this.page + '&revenue_type=' + this.option;
            try {
                ayzAjax.get(url,{
                    headers: {
                        'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                    }
                }).then((info) => {
                    if (info.data.code === 4){
                        return this.$router.push({ path: '/referral/login'});
                    }
                    if(info.data.code !== 200){
                        this.$router.push({ path: '/referral/index'});
                        return showFailToast(info.data.msg)
                    }
                    this.today_revenue = info.data.data.today_revenue
                    this.sum_revenue = info.data.data.sum_revenue
                    this.period_revenue = info.data.data.period_revenue
                    this.sum_children_revenue = info.data.data.sum_children_revenue
                    this.period_id = info.data.data.period_withdraw_id

                    info.data.data.revenues.forEach((item) => {
                        this.list.push(item)
                    });
                    this.loading = false;

                    if (info.data.data.revenues.length < 20) {
                        this.finished = true;
                    }else{
                        this.finished = false;
                        this.page ++
                    }
                    if (this.list.length > 0) {
                        this.loadingText = '到底了'
                    }else{
                      this.marSty = {marginTop: '100px'}
                    }
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试');
            }


        },

    }
}
</script>

<style lang="scss" scoped>

.reload-view {
    background-color: #F6F6F6;
    text-align: left;
    .top-back {
        background-image: url('~@/assets/referral-back2.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 120px;
        color: #FFFFFF;
        .code {
            padding-top: 30px;
            padding-left: 30px;
            font-weight: 600;
            font-size: 27px;
        }
        .top-text {
            margin-top: 15px;
            margin-left: 30px;
            margin-right: 25px;
            font-weight: 300;
            font-size: 14px;
        }
    }
    .main {
        min-height: 100px;
        margin: 12px;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;
        .main-top{
            width: 33%;
            height: 95px;
            //background: #F94B54;
            float: left;
            text-align: center;
            .main-top-num{
                margin-top: 25px;
                font-weight: 500;
                font-size: 18px;
                color: #222222;
            }
            .main-top-text{
                margin-top: 15px;
                font-weight: 300;
                font-size: 13px;
                color: #161616;
            }
        }
        .main-option{
            padding-top: 25px;
            margin-left: 15px;
            font-weight: 400;
            font-size: 13px;
            color: #C7C7C7;
            display: flex;
            .main-option-item{
                margin-right: 20px;
            }
        }
        .main-list{
            margin-top: 20px;
            .main-list-info{
                margin-top: 5px;
                height: 40px;
                //background: #F94B54;
                line-height: 40px;
                padding-left: 15px;
                font-size: 12px;
                .main-list-info-name{
                    float: left;
                    width: 100px;
                    color: #222222;
                    //font-weight: bold;
                }
                .main-list-info-price{
                    float: left;
                    width: 58px;
                    font-weight: bold;
                    color: #F94B54;
                }
                .main-list-info-text{
                    width: 70px;
                    float: left;
                    color: #161616;
                }
                .main-list-info-time{
                    float: left;
                    color: #161616;
                }
            }
        }

    }
}
.action{
    font-weight: bold;
    color: #222222;
}
</style>
